import { useGoogleLogin } from "@react-oauth/google";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import logo from "../Assets//images/logo.png";
import voxAppicon from "../Assets/images/VoxApp-Icon.png";
import { CloseEye } from "../Assets/svgs/CloseEye";
import { GoogleIcon } from "../Assets/svgs/GoogleIcon";
import { OpenEye } from "../Assets/svgs/OpenEye";
import { Loader } from "../Common/Loader";
import {
  emailValidation,
  getPhoneNumberLimits,
  handlePhoneNoChange,
  nameValidation,
  passwordValidation,
  phoneNumberValidation,
  validURL,
} from "../Common/Validations";
import { ErrorModel } from "../Model/ErrorModel";
import { SuccessModel } from "../Model/SuccessModel";
import { userSignUp } from "../Redux/Slice/Authentication/SignUpSlice";
import { saveCurrentUserData } from "../Redux/Slice/Common/CurrentUserSlice";
import { GetUserDetailsByToken } from "../Service/GoogleAPI";
import "../Style/scss/pages/login.scss";
import { SignInBanner } from "./SIgnInBanner";
import { ALL_CALLING_CODES } from "../Common/Constants";
import { maskNoByCallingCode } from "../Common/utils";
import CountryPhoneInput from "../Common/CountryPhoneInput";
import { getIndustryList } from "../Redux/Slice/Common/GetIndustryListSlice";
import Dropdown from "../Common/Dropdown";

export const SignUp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    companyName: "",
    companyWebsite: "",
    phoneNumber: "",
    industryType: "",
    password: "",
    confirmPassword: "",
    countryCallingCode: "+61",
    googleId: "",
  });
  const [formError, setFormError] = useState({
    emailError: "",
    phoneError: "",
    passowrdError: "",
    confirmPasswordError: "",
    firstNameError: "",
    lastNameError: "",
    companyNameError: "",
    industryTypeError: "",
    companyWebsiteError: "",
  });
  const [errorModel, setErrorModel] = useState(false);
  const [passwordType, setPasswordType] = useState(false);
  const [confirmPasswordType, setConfirmPasswordType] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successModal, setSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [profile, setProfile] = useState(false);
  const [user, setUser] = useState();
  const industryListData = useSelector(
    (s) => s?.industryList?.industryListData
  );

  const getDetails = async (user) => {
    const result = await GetUserDetailsByToken(user.access_token);
    setFormData((prev) => ({
      ...prev,
      email: result.body.email,
      firstName: result.body.given_name ? result.body.given_name : "",
      lastName: result.body.family_name ? result.body.family_name : "",
      phoneNumber: "",
      countryCallingCode: "+61",
      googleId: result.body.id,
    }));
    setProfile(result.body);
  };
  useEffect(() => {
    if (user) {
      getDetails(user);
    }
  }, [user]);

  useEffect(() => {
    dispatch(getIndustryList());
  }, []);

  const LoginWithGoogle = useGoogleLogin({
    onSuccess: (codeResponse) => setUser(codeResponse),
    onError: (error) => console.error("Login Failed:", error),
  });

  const handleChange = async (e) => {
    let { name, value } = e.target;
    value = value.trimStart();
    if (name === "email") {
      value = value.trimEnd();
      const isValid = emailValidation(value);
      setFormData({ ...formData, [name]: value, googleId: "" });
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, emailError: "" });
      } else {
        setFormError({ ...formError, emailError: "Please enter valid Email" });
      }
    } else if (name === "password") {
      const isValid = passwordValidation(value);
      setFormData({ ...formData, [name]: value });
      if (isValid || value == "") {
        setFormError({
          ...formError,
          passowrdError: "",
          confirmPasswordError:
            value &&
            formData.confirmPassword &&
            value !== formData.confirmPassword
              ? "Passwords don't match"
              : "",
        });
      } else {
        setFormError({
          ...formError,
          passowrdError:
            "Password must be 8 characters long and include at least one lowercase letter, one uppercase letter, one number, and one special character",
          confirmPasswordError:
            value &&
            formData.confirmPassword &&
            value !== formData.confirmPassword
              ? "Passwords don't match"
              : "",
        });
      }
    } else if (name === "confirmPassword") {
      setFormData({ ...formData, [name]: value });
      if (value && value !== formData.password) {
        setFormError({
          ...formError,
          confirmPasswordError: "Passwords don't match",
        });
      } else {
        setFormError({
          ...formError,
          confirmPasswordError: "",
        });
      }
    } else if (name === "firstName") {
      const isValid = nameValidation(value);
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, firstNameError: "" });
      } else {
        setFormError({
          ...formError,
          firstNameError: "Please enter valid name",
        });
      }
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      setFormData({ ...formData, [name]: value });
    } else if (name === "lastName") {
      const isValid = nameValidation(value);
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, lastNameError: "" });
      } else {
        setFormError({
          ...formError,
          lastNameError: "Please enter valid name",
        });
      }
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      setFormData({ ...formData, [name]: value });
    } else if (name === "companyName") {
      const isValid = nameValidation(value);
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, companyNameError: "" });
      } else {
        setFormError({
          ...formError,
          companyNameError: "Please enter valid company name",
        });
      }
      let capitalized = value.charAt(0).toString().toUpperCase();
      value = capitalized + value.substring(1);
      setFormData({ ...formData, [name]: value });
    } else if (name === "companyWebsite") {
      const isValid = validURL(value);
      if (isValid || value.trim() === "") {
        setFormError({ ...formError, companyWebsiteError: "" });
      } else {
        setFormError({
          ...formError,
          companyWebsiteError: "Please enter valid company website",
        });
      }
      setFormData({ ...formData, [name]: value });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handlSubmit = async () => {
    const data = {
      ...formData,
      phoneNumber: formData.phoneNumber.replace(/\D/g, ""),
      companyName: formData.companyName,
      companyWebsite: formData.companyWebsite,
      createdByCustomer: false,
    };
    setIsLoading(true);
    const result = await dispatch(userSignUp(data));
    if (
      userSignUp.fulfilled.match(result) &&
      result?.payload?.success === true
    ) {
      setIsLoading(false);
      if (result.payload?.data?.access_token) {
        localStorage.setItem("userData", JSON.stringify(result?.payload?.data));
        dispatch(saveCurrentUserData(result?.payload?.data));
        setSuccessMessage("Sign up Successfully!");
        setSuccessModal(true);
        setTimeout(() => {
          setSuccessModal(false);
          if (result?.payload?.data?.role?.name === "superadmin") {
            navigate("/dashboard");
          } else {
            const isPaymentMethodAdded = result?.payload?.data?.customer
              ? result?.payload?.data?.customer?.isPaymentMethodAdded
              : true;
            if (!isPaymentMethodAdded) {
              navigate("/free-trial");
            } else {
              navigate("/dashboard");
            }
          }
        }, 1500);
      } else if (result.payload?.data?.otpToken) {
        setSuccessMessage("Email verification code sent on your Email");
        setSuccessModal(true);
        setTimeout(() => {
          setSuccessModal(false);
          navigate("/otpverification", {
            state: {
              email: formData.email,
              otpToken: result?.payload?.data?.otpToken,
            },
          });
        }, 1500);
      } else {
        navigate("/qr-scanner", {
          state: {
            email: formData.email,
            mfaCredToken: result?.payload?.data?.mfaCredToken,
            isRedirectedFromSignup: true,
          },
        });
      }
    } else {
      //TODO: error popup here
      setIsLoading(false);
      setErrorMessage(result?.payload?.error?.message);
      setErrorModel(true);
      setTimeout(() => {
        setErrorModel(false);
      }, 1500);
    }
  };

  const handleCountryCodeChange = async (e) => {
    const { name, value } = e.target;

    let formatted = formData.phoneNumber;
    setFormData({ ...formData, [name]: value, phoneNumber: formatted });
    const minDigits = getPhoneNumberLimits(value)?.min ?? 10;
    const rawDigits = formData.phoneNumber.replace(/\D/g, "");
    const isValid = phoneNumberValidation(rawDigits, value);
    setFormError({
      ...formError,
      phoneError:
        isValid || value === ""
          ? ""
          : rawDigits.length < minDigits
          ? `Phone number must be at least ${minDigits} digits long.`
          : "Please enter a valid phone number",
    });
  };

  const handlePhoneChange = async (e) => {
    let { name, value } = e.target;
    handlePhoneNoChange(
      e,
      formData.countryCallingCode,
      () => setFormData({ ...formData, [name]: value }),
      (newError) => setFormError({ ...formError, phoneError: newError }),
      () => {},
      false
    );
  };

  const formattedIndustryList = useMemo(() => {
    if (!Array.isArray(industryListData)) return [];

    return industryListData.map((item) => ({
      label: item?.name,
      value: item?.name,
    }));
  }, [industryListData]);

  const isFormDisabled =
    formData.firstName.trim() === "" ||
    formData?.lastName?.trim() === "" ||
    formData?.companyName.trim() === "" ||
    formData?.companyWebsite?.trim() === "" ||
    !formData?.industryType ||
    formError.emailError != "" ||
    formError.passowrdError != "" ||
    formError.phoneError != "" ||
    formError.firstNameError != "" ||
    formError.lastNameError != "" ||
    formError.companyNameError != "" ||
    formError.companyWebsiteError != "" ||
    formData.phoneNumber === "" ||
    formData.email.trim() === "" ||
    (formData.googleId === "" && formData.password === "") ||
    (formData.googleId === "" && formData.confirmPassword === "") ||
    (formData.googleId === "" && formError.confirmPasswordError);

  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
        if (!isFormDisabled) {
          handlSubmit();
        }
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [isFormDisabled]);

  return (
    <section className="signup">
      {successModal ? <SuccessModel message={successMessage} /> : ""}
      {errorModel ? <ErrorModel message={errorMessage} /> : ""}
      {isLoading ? <Loader /> : ""}
      <div className="signup__flex">
        <SignInBanner />
        <div className="signup__item signup__item--form">
          {/* <div className="signup__mainHeader">
            <div className="branding">
              <div className="branding__logo">
                <img
                  src={logo}
                  alt="Logo | Vox App"
                  className="branding__logo__img"
                />
              </div>
            </div>
          </div> */}
          <div className="signup__form">
            <div className="signup__form__header">
              <div className="branding">
                <div className="branding__logo">
                  <img
                    src={logo}
                    alt="Logo | Vox App"
                    className="branding__logo__img"
                  />
                </div>
                <div className="branding__info">
                  <h1 className="title title--h1">Create an account</h1>
                </div>
                <button
                  className="btn btn__white btn--full"
                  onClick={LoginWithGoogle}
                >
                  Create account with Google
                  <GoogleIcon />
                </button>
                <div className="signup__form--divider">
                  <span>Or</span>
                </div>
              </div>
            </div>
            <div className="signup__form__body">
              <div className="form__group">
                <label for="firstname" className="form__label">
                  First Name <span style={{ color: "red" }}> * </span>
                </label>
                <div className="form__groupField">
                  <input
                    type="text"
                    maxLength={30}
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    id="firstname"
                    autoComplete="off"
                    className="form__input"
                    placeholder="Enter your first name"
                  />
                </div>
                <div className="form__error">{formError.firstNameError}</div>
              </div>
              <div className="form__group">
                <label for="lastname" className="form__label">
                  Last Name <span style={{ color: "red" }}> * </span>
                </label>
                <div className="form__groupField">
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    id="lastname"
                    maxLength={30}
                    className="form__input"
                    autoComplete="off"
                    placeholder="Enter your last name"
                  />
                </div>
                <div className="form__error">{formError.lastNameError}</div>
              </div>
              <div className="form__group">
                <label for="email" className="form__label">
                  Email Address <span style={{ color: "red" }}> * </span>
                </label>
                <div className="form__groupField">
                  <input
                    type="text"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form__input"
                    autoComplete="off"
                    maxLength={100}
                    placeholder="Enter your email address"
                  />
                </div>
                <div className="form__error">{formError.emailError}</div>
              </div>
              <div className="form__group">
                <label for="companyName" className="form__label">
                  Company Name <span style={{ color: "red" }}> * </span>
                </label>
                <div className="form__groupField">
                  <input
                    type="text"
                    name="companyName"
                    value={formData.companyName}
                    onChange={handleChange}
                    id="companyName"
                    maxLength={30}
                    className="form__input"
                    autoComplete="off"
                    placeholder="Enter your company name"
                  />
                </div>
                <div className="form__error">{formError.companyNameError}</div>
              </div>
              <div className="form__group">
                <label for="companyWebsite" className="form__label">
                  Company Website <span style={{ color: "red" }}> * </span>
                </label>
                <div className="form__groupField">
                  <input
                    type="text"
                    name="companyWebsite"
                    value={formData.companyWebsite}
                    onChange={handleChange}
                    id="companyWebsite"
                    maxLength={100}
                    className="form__input"
                    autoComplete="off"
                    placeholder="Enter your company website"
                  />
                </div>
                <div className="form__error">
                  {formError.companyWebsiteError}
                </div>
              </div>
              <div className="form__group">
                <label for="industryType" className="form__label">
                  Industry <span style={{ color: "red" }}> * </span>
                </label>
                <Dropdown
                  id="industryType"
                  name="industryType"
                  options={formattedIndustryList}
                  placeholder="-Select-"
                  creatable
                  selectedValue={formData.industryType}
                  onChange={(selectedOption) =>
                    setFormData((prev) => ({
                      ...prev,
                      industryType: selectedOption?.label,
                    }))
                  }
                />
                <div className="form__error">{formError?.industryTypeError}</div>
              </div>
              <div className="form__group">
                <div className="form__Field">
                  <label for="phonenumber" className="form__label">
                    Phone Number <span style={{ color: "red" }}> * </span>
                  </label>
                  <CountryPhoneInput
                    countryCodeFieldName="countryCallingCode"
                    phoneFieldName="phoneNumber"
                    countryCode={formData.countryCallingCode}
                    phoneNumber={formData.phoneNumber}
                    onCountryChange={handleCountryCodeChange}
                    onPhoneChange={handlePhoneChange}
                    inputStyle={{ height: "56px", fontSize: "1rem" }}
                  />
                  <div className="form__error">{formError.phoneError}</div>
                </div>
              </div>
              {formData.googleId === "" ? (
                <>
                  <div className="form__group">
                    <label for="password" className="form__label">
                      Password <span style={{ color: "red" }}> * </span>
                    </label>
                    <div className="form__groupField">
                      <input
                        type={passwordType ? "text" : "password"}
                        id="password"
                        className="form__input"
                        onChange={handleChange}
                        name="password"
                        autoComplete="off"
                        value={formData.password}
                        maxLength={16}
                        placeholder="Create your password"
                      />
                      <button
                        className="btn"
                        onClick={(e) => {
                          setPasswordType(!passwordType);
                        }}
                      >
                        {passwordType ? <OpenEye /> : <CloseEye />}
                      </button>
                      <button className="btn"></button>
                    </div>
                    <div className="form__error">{formError.passowrdError}</div>
                  </div>
                  <div className="form__group">
                    <label for="confirmPassword" className="form__label">
                      Confirm Password <span style={{ color: "red" }}> * </span>
                    </label>
                    <div className="form__groupField">
                      <input
                        type={confirmPasswordType ? "text" : "password"}
                        id="confirmPassword"
                        className="form__input"
                        onChange={handleChange}
                        name="confirmPassword"
                        autoComplete="off"
                        value={formData.confirmPassword}
                        maxLength={16}
                        placeholder="Create your password"
                      />
                      <button
                        className="btn"
                        onClick={(e) => {
                          setConfirmPasswordType(!confirmPasswordType);
                        }}
                      >
                        {confirmPasswordType ? <OpenEye /> : <CloseEye />}
                      </button>
                      <button className="btn"></button>
                    </div>
                    <div className="form__error">
                      {formError.confirmPasswordError}
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              <div className="form__button">
                <button
                  disabled={isFormDisabled}
                  onClick={handlSubmit}
                  className="btn btn__mintGreen btn--full"
                  type="submit"
                >
                  Register
                </button>
                <button
                  onClick={() => {
                    navigate("/");
                  }}
                  className="btn btn__outlined btn--full"
                  type="submit"
                >
                  Sign in
                </button>
              </div>
            </div>
            <div className="signup__form__footer">
              <p className="para para--center">
                See what works best for you.
                <a
                  className="link link__primary"
                  target="_blank"
                  href="https://www.voxapp.com/pricing"
                >
                  Browse Plans
                </a>
              </p>
              {/* <ul className="socialLink">
              <li className="socialLink__item">
                <a className="socialLink__link" href="#">
                  <FacebbokIcon />
                </a>
              </li>
              <li className="socialLink__item">
                <a className="socialLink__link" href="#">
                  <TwitterIcon />
                </a>
              </li>
              <li className="socialLink__item">
                <a className="socialLink__link" href="#">
                  <InstaIcon />
                </a>
              </li>
              <li className="socialLink__item">
                <a className="socialLink__link" href="#">
                  <LinkedInIcon />
                </a>
              </li>
            </ul> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
